import { render, staticRenderFns } from "./deleteRoleShop.vue?vue&type=template&id=aeda4328&scoped=true"
import script from "./deleteRoleShop.vue?vue&type=script&lang=js"
export * from "./deleteRoleShop.vue?vue&type=script&lang=js"
import style0 from "./deleteRoleShop.vue?vue&type=style&index=0&id=aeda4328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeda4328",
  null
  
)

export default component.exports